import { render, staticRenderFns } from "./MBlog.vue?vue&type=template&id=2964f6c2&"
import script from "./MBlog.vue?vue&type=script&lang=js&"
export * from "./MBlog.vue?vue&type=script&lang=js&"
import style0 from "./MBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports